import { useEffect, useRef } from "react";

/**
 * Runs a callback exactly once, when the component first mounts
 * - the callback does not re-run while its component remains mounted or if the component re-mounts
 * - the callback may be async, but this hook will not await it
 */
export function useOnInitialMount(callback: () => void | Promise<void>) {
  const callbackRef = useRef(callback);
  const hasRun = useRef(false);
  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    void callbackRef.current();
  }, []);
}
